module.exports = __webpack_public_path__ + "static/media/MU_Landing_Page_TC_16x9.b115e0f4.vtt";